export const projectIntegrationSearchParams = {
  code: 'code',
  state: 'state',
};
